import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IMajorCareer } from '../../major_explorer_interface';
import { MajorProgram } from './../builders/major_programs_builder';

export class MajorTileFunction {
  constructor(private saveMajorCommand: ICommand, private unsaveMajorCommand: ICommand) {}

  addFavorite(major: MajorProgram): void {
    if (major._isUpdating) {
      return;
    }
    major.is_favorite = !major.is_favorite;
    major._isUpdating = true;

    if (major.is_favorite) {
      this.saveMajorCommand(major)
        .then((updatedMajor: MajorProgram) => {
          major.favorite_id = updatedMajor.favorite_id;
          major._isUpdating = false;
        })
        .finally(() => {
          major._isUpdating = false;
        });
    } else {
      this.unsaveMajorCommand(major).finally(() => {
        major._isUpdating = false;
      });
    }
  }

  showAverageSalary(major: MajorProgram): boolean {
    return major && !_4.isUndefined(major.salary_trend_max) && major.salary_trend_max !== '$0k';
  }

  buildCareers(careerPayload: any) {
    const fallbackCareerData = {
      hiring_demand: 'N/A',
      salaryMin: 'N/A',
      salaryMax: 'N/A',
      topSkills: [],
      experience: [],
      education: []
    };

    _4.map(careerPayload.allCareers, (career: IMajorCareer) => {
      const matchedCareer =
        _4.find(careerPayload.careersData, (detail: any) => {
          return detail.careerId === career.id;
        }) || fallbackCareerData;
      const { hiring_demand, salaryMin, salaryMax, topSkills, experience, education } = matchedCareer;

      return _4.merge(career, { hiring_demand, salaryMin, salaryMax, topSkills, experience, education });
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/functions/major_tile_fn.ts